import { api } from './api';

export interface AcertoPromotorVendas {
  idRomaneio: number;
  nomePromotor: string;
  nomePraca: string;
  dataSaida: string;
  dataRetorno: string;
  quantidadeSaidasVinculadas: number;
  quantidadeRetornosNoPeriodo: number;
  valorTotalCobranca: number;
  totalRecebido: number;
  valorReceber?: number;
}

export interface AcertoPromotorVendasFiltro {
  idPromotor?: number;
  idPraca?: number;
  idRomaneio?: number;
}

export const acertoPromotorVendasService = {
  consultar: async (filtro: AcertoPromotorVendasFiltro): Promise<AcertoPromotorVendas[]> => {
    const params = new URLSearchParams();
    if (filtro.idPromotor) params.append('idPromotor', filtro.idPromotor.toString());
    if (filtro.idPraca) params.append('idPraca', filtro.idPraca.toString());
    if (filtro.idRomaneio) params.append('idRomaneio', filtro.idRomaneio.toString());

    const response = await api.get<AcertoPromotorVendas[]>(`/api/AcertoPromotorVendas/ConsultarAcertoPromotorVendas?${params.toString()}`);
    return response.data;
  },
};
